const config = {
  server: {
    url:
      process.env.VUE_APP_API_URL ||
      'https://www.cottonsociety.com/cashdesk/api'
  }
}

export default config



// WEBPACK FOOTER //
// ./src/config/index.js